import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import './Contact.css';

const Contact = () => {
    const clinics = [
        {
            name: "Fisioterapia Pinseque",
            address: "C. San Pedro Mártir, 15, 50298 Pinseque, Zaragoza",
            phone: "690051174",
            phoneDisplay: "690 05 11 74",
            email: "info@fisioterapiapinseque.com"
        },
        {
            name: "Fisioterapia Pedrola",
            address: "C. Zaragoza, 27, 50690 Pedrola, Zaragoza",
            phone: "663881580",
            phoneDisplay: "663 88 15 80",
            email: "info@fisiopedrola.com"
        }
    ];

    const handleMapClick = (address) => {
        const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
        window.open(mapsUrl, '_blank');
    };

    const handlePhoneClick = (phone) => {
        window.location.href = `tel:${phone}`;
    };

    const handleEmailClick = (email) => {
        window.location.href = `mailto:${email}`;
    };

    return (
        <div className="contact-page">
            <div className="contact-header">
                <h1>Contacto</h1>
                <p>Estamos aquí para ayudarte. Contáctanos para cualquier duda o cita.</p>
            </div>

            <div className="container">
                <div className="clinics-wrapper">
                    {clinics.map((clinic, index) => (
                        <div key={index} className="clinic-section">
                            <h2 className="clinic-name">{clinic.name}</h2>
                            <div className="clinic-info-grid">
                                <div className="info-card clickable" onClick={() => handleMapClick(clinic.address)}>
                                    <MapPin className="info-icon" size={24} />
                                    <h3>Ubicación</h3>
                                    <p>{clinic.address}</p>
                                    <span className="click-hint">Click para abrir en Maps</span>
                                </div>

                                <div className="info-card clickable" onClick={() => handlePhoneClick(clinic.phone)}>
                                    <Phone className="info-icon" size={24} />
                                    <h3>Teléfono</h3>
                                    <p className="contact-link">{clinic.phoneDisplay}</p>
                                    <span className="click-hint">Click para llamar</span>
                                </div>

                                <div className="info-card clickable" onClick={() => handleEmailClick(clinic.email)}>
                                    <Mail className="info-icon" size={24} />
                                    <h3>Email</h3>
                                    <p className="contact-link">{clinic.email}</p>
                                    <span className="click-hint">Click para enviar email</span>
                                </div>

                                <div className="info-card">
                                    <Clock className="info-icon" size={24} />
                                    <h3>Horario</h3>
                                    <p>Lunes - Viernes<br />9:00 - 13:00 / 16:00 - 20:00</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Contact;
